import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Structures } from '@clavisco/core';
import { IUserHelpDocumentationLinkEntity } from '@clavisco/user-help';
import { Observable } from 'rxjs';

/**
 * Service for managing user help documentation links.
 * Provides methods to retrieve, create, and update documentation links.
 */
@Injectable({
  providedIn: 'root'
})
export class UserHelpService {

  /**
   * API controller endpoint for user help operations
   */
  private readonly CONTROLLER = 'api/UserHelp';

  constructor(private http: HttpClient) { }

  /**
   * Retrieves one or many documentation links
   * @param pShouldSkipAlert Indicates if the error interceptor should exclude this request
   * @param pId (Optional) Documentation link identifier
   * @returns Observable with the documentation link(s)
   */
  Get(pShouldSkipAlert?: boolean, pId?: number): Observable<Structures.Interfaces.ICLResponse<IUserHelpDocumentationLinkEntity[] | IUserHelpDocumentationLinkEntity>>
  {
    let endpointToRequest: string = pId ? `${this.CONTROLLER}/${pId}` : this.CONTROLLER;
    return this.http.get<Structures.Interfaces.ICLResponse<IUserHelpDocumentationLinkEntity[] | IUserHelpDocumentationLinkEntity>>(endpointToRequest, {
      headers: pShouldSkipAlert ? new HttpHeaders().append("X-Skip-Alert", "true") : undefined
    });
  }

  /**
   * Creates a new documentation link
   * @param pDocumentationLink The documentation link entity to create
   * @returns Observable with the created documentation link
   */
  Post(pDocumentationLink: IUserHelpDocumentationLinkEntity): Observable<Structures.Interfaces.ICLResponse<IUserHelpDocumentationLinkEntity>>
  {
    return this.http.post<Structures.Interfaces.ICLResponse<IUserHelpDocumentationLinkEntity>>(this.CONTROLLER, pDocumentationLink);
  }

  /**
   * Updates an existing documentation link
   * @param pDocumentationLink The documentation link entity to update
   * @returns Observable with the updated documentation link
   */
  Patch(pDocumentationLink: IUserHelpDocumentationLinkEntity): Observable<Structures.Interfaces.ICLResponse<IUserHelpDocumentationLinkEntity>>
  {
    return this.http.patch<Structures.Interfaces.ICLResponse<IUserHelpDocumentationLinkEntity>>(this.CONTROLLER, pDocumentationLink);
  }
}
